
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type CourseResponseSectionsItemLecturesItemPlatformSupport = typeof CourseResponseSectionsItemLecturesItemPlatformSupport[keyof typeof CourseResponseSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseResponseSectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
